<script>
  import {onMount,createEventDispatcher} from 'svelte'
  import { fade,scale } from 'svelte/transition';
  import {shareUrl,preload} from './../common.js'

  const dispatch = createEventDispatcher();


  export let lang ="en";
  export let labels;
  export let userapp;
  let install = true;
  let showModal = false;
  let iconLoaded = false;  
  let loader = true;
  const browser = navigator.userAgent.match(/safari/i);
  const ios13 = navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*CPU.*OS 13_\d/i);
  const iconImage =userapp.files+"/apple-touch-icon-precomposed.png?v="+userapp.version; 
  let safari = true;

  preloadIt();
  
  function preloadIt(){

      setTimeout(function(){
        
        preload("https://igappfiles.azureedge.net/public/native/Instructions-IOS2.png");
        preload("https://igappfiles.azureedge.net/public/native/spinner2.png");
        
      },200);
    
  }

  function handleInstall(){
      showModal = true;
      install = false;
      console.log('load '+ loader);

      setTimeout(function(){
        loader = false;
        console.log('stop')
      },3000)
  }
  function handleTrust()
  {
      loader =true;
      setTimeout(function(){
        loader = false;
        console.log('stop')
      },3000)
  }
</script>

<div id="ios">
  <div id="a2hios" class="a2h">
    <div class="ios-header-container">
      <div class="ios-icon-container">
    
        <img
          id="iconimg"
          src="{iconImage}"
          alt="icon"
          class:iconLoaded
          on:load={()=>{iconLoaded =true}}
          />
       
      </div>
      <div class="ios-title-container">
        <h2 id="ios-title">{@html userapp.title}</h2>
        <p id="ios-by">{@html userapp.user}</p>
        {#if install}
          {#if safari}
            <a
              on:click={handleInstall}
              id="ios-install-button"
              style="display: inline;"
              href="itms-services://?action=download-manifest&url=https://app.igenapps.com/native/plist/{userapp.appid}"
              >
              {labels.ios.install}
              
            </a>
          {:else}
            
              <a id="ios-open-button" style="background-color:gray!important" href="javascript:OpenSafari()"> {labels.ios.open}</a>
            
          {/if}
        {:else}
          {#if loader}
            <div class="iosloader">
                <img src="https://igappfiles.azureedge.net/public/native/spinner2.png" alt="l" />
            </div>
          {:else}
            <a id="ios-cert-button" on:click={handleTrust} href="https://igenappsfiles.blob.core.windows.net/public/ipa/iGenApps.mobileprovision" data-localize="ios.trust"> {labels.ios.trust}</a>
          {/if}  
        {/if}      
        </div>
      </div>
    </div>

    
    {#if showModal}
      <div class="options" id="ios-instructions" in:fade={200}>
        <a href="https://igenappsfiles.blob.core.windows.net/public/ipa/iGenApps.mobileprovision" data-rel="external"><img src="https://igappfiles.azureedge.net/public/native/Instructions-IOS2.png" alt="Instructions" style="width:100%" /></a>
      </div>
    {:else}
    <div class="ios-rating-container">
      <p class="rating">
        <span in:fade={250}>5.0</span>
        <span>
        {#each Array(5) as i,index}
            {#if i===i}
            
              <svg in:scale={{duration:250,delay:100 * index}} height="20px" viewBox="0 -10 511.99143 511" width="20px" xmlns="http://www.w3.org/2000/svg"><path d="m510.652344 185.882812c-3.371094-10.367187-12.566406-17.707031-23.402344-18.6875l-147.796875-13.417968-58.410156-136.75c-4.3125-10.046875-14.125-16.53125-25.046875-16.53125s-20.738282 6.484375-25.023438 16.53125l-58.410156 136.75-147.820312 13.417968c-10.835938 1-20.011719 8.339844-23.402344 18.6875-3.371094 10.367188-.257813 21.738282 7.9375 28.925782l111.722656 97.964844-32.941406 145.085937c-2.410156 10.667969 1.730468 21.699219 10.582031 28.097656 4.757813 3.457031 10.347656 5.183594 15.957031 5.183594 4.820313 0 9.644532-1.28125 13.953125-3.859375l127.445313-76.203125 127.421875 76.203125c9.347656 5.585938 21.101562 5.074219 29.933593-1.324219 8.851563-6.398437 12.992188-17.429687 10.582032-28.097656l-32.941406-145.085937 111.722656-97.964844c8.191406-7.1875 11.308594-18.535156 7.9375-28.925782zm-252.203125 223.722657"/></svg>
            {/if}
        {/each} 
        </span>
      </p>
    </div>

    <div class="ios-line" id="ios-div-scroll" />
    <div class="ios-desc-container">
      <p id="ios-desc">
        {@html userapp.desc}
      </p>
    </div>
    <div class="ios-line" />
    <div class="ios-info-container">
      <h2>{labels.ios.information}</h2>
      
      <table
        style="margin-top:-10px; margin-left:0;margin-right:0; width:100%"
        cellspacing="0">
        <tbody>
          <tr>
            <td>
              <small>
                <span>{labels.ios.creator}</span>
              </small>
            </td>
            <td align="right">
              <small>
                <span id="ios-span-by">{@html userapp.user}</span>
              </small>
            </td>
          </tr>
          <tr>
            <td>
              <small>
                <span>{labels.ios.category}</span>
              </small>
            </td>
            <td align="right">
              <small>
                <span id="ios-span-cat">{@html userapp.cat}</span>
              </small>
            </td>
          </tr>
          <tr>
            <td>
              <small>
                <span>{labels.ios.compat}</span>
              </small>
            </td>
            <td align="right">
              <small>
                <span>{labels.ios.requires}</span>
              </small>
            </td>
          </tr>
          <tr>
            <td>
              <small>
                <span>{labels.ios.updated}</span>
              </small>
            </td>
            <td align="right">
              <small>
                <span id="ios-span-created">{userapp.updated}</span>
              </small>
            </td>
          </tr>
          <tr>
            <td>
              <small>
                <span data-localize="version">{labels.version}</span>
              </small>
            </td>
            <td align="right">
              <small>
                <span id="ios-span-ver">{userapp.version}.0</span>
              </small>
            </td>
          </tr>
        </tbody>
      </table>
      
      </div>
      
      {/if}
    
   </div>
 

<style>
  #a2hios h2 {
    font-family: Arial;
    font-weight: 300;
  }

  #iconimg {
    width: 112px;
    height: 112px;
    margin:0;
    padding:0;
    border-radius: 25px;
   
  
  }
  tr td:first-child{
    color: #747474;
   }
  .ios-line {
    border-bottom: 0.5px solid #eaeaea;
    border-width: 0.5px;
    height: 1px;
    margin: 0 21px 0 21px;
  }

  .ios-header-container {
    height: 144px;
  }

  .ios-icon-container {
    display: inline-block;
    width:112px;
    height:112px;
    margin: 20px;
    padding:0;
    border: 1px solid rgba(180, 180, 180, 0.5);
    border-radius: 25px;
    box-sizing:content-box;
  }

  .ios-title-container {
    vertical-align: top;
    display: inline-block;
    padding-top: 20px;
    height:135px;
    width: calc(100% - 180px)!important;
    margin-left:-3px;
  }

  .ios-title-container h2 {
    font-size: 1.3em !important;
    margin: 0;
    font-weight: bold !important;
    word-break: break-word;
    max-width: 99% !important;
    display: block;
    display: -webkit-box;
    overflow: hidden;
    line-height: 1.3em;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    -ms-text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    padding-bottom: 0px;
  }

  .ios-title-container p {
    padding-top:1px;
    margin: 0 5px 0 0;
    color: #737373;
    width: 99% !important;
    word-break: break-word;
    white-space: nowrap;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    -ms-text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
  }

#ios-install-button, #ios-open-button,#ios-cert-button{
    position: absolute;
    top: 105px;
    margin: 0;
    border: none ;
    border-radius: 100px ;
    text-shadow: none ;
    box-shadow: none ;
    color: #fff ;
    background-color: #0071EB ;
    font-family: Arial;
    font-size: 0.9em ;
    font-weight: 600 ;
    letter-spacing: 0.5px;
    padding: 0.454em 1.143em 0.354em 1.143em ;
    text-decoration:none;
    user-select: none;
    -webkit-tap-highlight-color:transparent;
}

  .ios-desc-container {
    min-height: 20px;
  }

  .ios-desc-container p {
    margin-left: 21px;
    margin-right: 21px;
    margin-top: 12px;
    margin-bottom: 12px;
    line-height: 1.2em;
    display: inline-block;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .ios-desc-container:hover p,
  .ios-desc-container:active p, 
  .ios-desc-container:focus p {
    display: inline-block;
    overflow: visible;
  }

  .ios-info-container {
    margin-left: 21px;
    margin-right: 21px;
    margin-bottom: 10px;
  }

  .ios-info-container h2 {
    margin-left: 0;
    margin-right: 0;
    margin-top: 12px;
    font-weight: bold !important;
    letter-spacing: -0.2px;
  }

  .ios-rating-container .rating {
    color: #737373;
    font-size: 1.4em;
    font-weight: 500;
  }

  .ios-rating-container p {
    margin-left: 21px;
    margin-right: 21px;
    margin-bottom: 12px;
    margin-top:0;
  }

  .ios-rating-container svg{
    height: 17px;
    margin: 0px;
    margin-top: 5px;
    margin-left: 3px;
    fill: #737373;
  }


  .ios-info-container td {
    border-bottom: 0.5px solid #eeecec;
    border-width: 0.5px;
    height: 46px;
  }

  .ios-info-container td small span {
    font-size: 1.15em;
  }
.iosloader {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 105px;
    margin: 0;
   
}
.iosloader img{
 
    transform: translateZ(0);
    
    animation: load8 1.5s infinite linear;
    width: 30px;
    height: 30px;
    padding:0;
    margin:0;

}
    @keyframes load8 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }

        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
</style>
